export default __webpack_public_path__ + "static/16-8cf56fd9797001005dbe0b904b5ec9a0.jpg";